import { randomNumber } from '../../../../utilities'
import { AirwayConstants } from './airway.constants'
import { IAirwayAction, IAirwayState } from './airway.types'

export const initialAirwayState: IAirwayState = {
  action: null,
  flow: '',
  fiO2: '',
  via: null,
  humidity: '',
  oralPharyngealAirway: false,
  airTemperature: '',
  airTemperatureUnit: null,
  airTemperatureBool: true,
  airwayComplications: [],
  airwayComplicationsPNNV: null,
  pressure: '',
  inspiratoryPressure: '',
  expiratoryPressure: '',
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Airway',
  size: '',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  verificationMethod: [],
  isEkgImport: null,
  airwayDefaults: null,
  nemsisCode: null,
  reasonsForFailure: [],
}

export function airwayReducer(state: IAirwayState = initialAirwayState, action: IAirwayAction): IAirwayState {
  switch (action.type) {
    case AirwayConstants.SET_ACTION:
      return { ...state, action: action.action }
    case AirwayConstants.SET_FLOW:
      return { ...state, flow: action.flow }
    case AirwayConstants.SET_FIO2:
      return { ...state, fiO2: action.fiO2 }
    case AirwayConstants.SET_VIA:
      return { ...state, via: action.via }
    case AirwayConstants.SET_HUMIDITY:
      return { ...state, humidity: action.humidity }
    case AirwayConstants.SET_ORAL_PHARYNGEAL_AIRWAY:
      return { ...state, oralPharyngealAirway: action.oralPharyngealAirway }
    case AirwayConstants.SET_AIR_TEMPERATURE:
      return { ...state, airTemperature: action.airTemperature }
    case AirwayConstants.SET_AIR_TEMPERATURE_UNIT:
      return { ...state, airTemperatureBool: action.airTemperatureBool }
    case AirwayConstants.SET_AIR_TEMPERATURE_UNIT_TEMP:
      return { ...state, airTemperatureUnit: action.airTemperatureUnit }
    case AirwayConstants.SET_AIRWAY_COMPLICATIONS:
      return { ...state, airwayComplications: action.airwayComplications }
    case AirwayConstants.SET_AIRWAY_COMPLICATIONS_PNNV:
      return { ...state, airwayComplicationsPNNV: action.airwayComplicationsPNNV }
    case AirwayConstants.SET_VERIFICATION_METHOD:
      return { ...state, verificationMethod: action.verificationMethod }
    case AirwayConstants.SET_PRESSURE:
      return { ...state, pressure: action.pressure }
    case AirwayConstants.SET_INSPIRATORY_PRESSURE:
      return { ...state, inspiratoryPressure: action.inspiratoryPressure }
    case AirwayConstants.SET_EXPIRATORY_PRESSURE:
      return { ...state, expiratoryPressure: action.expiratoryPressure }
    case AirwayConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case AirwayConstants.SET_DATE:
      return { ...state, date: action.date }
    case AirwayConstants.SET_TIME:
      return { ...state, time: action.time }
    case AirwayConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case AirwayConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case AirwayConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case AirwayConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case AirwayConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case AirwayConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case AirwayConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case AirwayConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case AirwayConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case AirwayConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case AirwayConstants.SET_STATE:
      return { ...action.airwayState, updateInputRows: true }
    case AirwayConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case AirwayConstants.SET_SIZE:
      return { ...state, size: action.size }
    case AirwayConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case AirwayConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case AirwayConstants.SET_AIRWAY_DEFAULTS:
      return { ...state, airwayDefaults: action.airwayDefaults }
    case AirwayConstants.SET_REASONS_FOR_FAILURE:
      return { ...state, reasonsForFailure: action.reasonsForFailure }
    case AirwayConstants.RESET_STATE:
      return {
        action: null,
        flow: '',
        fiO2: '',
        via: null,
        humidity: '',
        oralPharyngealAirway: false,
        airTemperature: '',
        airTemperatureUnit: null,
        airTemperatureBool: true,
        airwayComplications: [],
        airwayComplicationsPNNV: null,
        pressure: '',
        inspiratoryPressure: '',
        expiratoryPressure: '',
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Airway',
        size: '',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        verificationMethod: [],
        isEkgImport: null,
        airwayDefaults: null,
        nemsisCode: null,
        reasonsForFailure: [],
      }
    default:
      return state
  }
}
